var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2153_16728)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.236 25.4588H39.764C40.1904 25.4588 40.5766 25.1901 40.7253 24.79C40.8735 24.39 40.7562 23.9345 40.4332 23.6563L30.669 15.2485C30.4831 15.0882 30.2454 15 29.9999 15C29.7545 15 29.5168 15.0882 29.3308 15.2485L19.5669 23.6563C19.2438 23.9345 19.1264 24.3901 19.2748 24.7903C19.4234 25.1901 19.8097 25.4588 20.236 25.4588Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.764 39.3555H20.236C19.6706 39.3555 19.2107 39.8155 19.2107 40.3808V41.9747C19.2107 42.54 19.6707 43 20.236 43H39.764C40.3294 43 40.7893 42.54 40.7893 41.9747V40.3808C40.7893 39.8155 40.3293 39.3555 39.764 39.3555Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8547 26.8235C20.7076 26.8235 20.588 26.9431 20.588 27.0902V37.2433C20.588 37.3903 20.7077 37.51 20.8547 37.51H24.2202C24.3672 37.51 24.4868 37.3903 24.4868 37.2433V27.0902C24.4868 26.9432 24.3672 26.8235 24.2202 26.8235H20.8547Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3172 26.8235C28.1701 26.8235 28.0505 26.9431 28.0505 27.0902V37.2433C28.0505 37.3903 28.1702 37.51 28.3172 37.51H31.6827C31.8298 37.51 31.9494 37.3903 31.9494 37.2433V27.0902C31.9494 26.9432 31.8297 26.8235 31.6827 26.8235H28.3172Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7798 26.8235C35.6327 26.8235 35.5131 26.9431 35.5131 27.0902V37.2433C35.5131 37.3903 35.6327 37.51 35.7798 37.51H39.1453C39.2924 37.51 39.412 37.3903 39.412 37.2433V27.0902C39.412 26.9432 39.2923 26.8235 39.1453 26.8235H35.7798Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_16728",
    x1: 7,
    y1: 10.5,
    x2: 45.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69185"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.5a0a8b6c753872b83d0bb7d3c4cf4702.svg";
export { ForwardRef as ReactComponent };